import { createContext } from "react";

const AppContext = createContext();

export { AppContext };
